import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";
import { dataType } from "../dataType";

@Component({
  selector: "app-create-group",
  templateUrl: "./create-group.component.html",
  styleUrls: ["./create-group.component.css"]
})
export class CreateGroupComponent {
  data: dataType[];
  bucketData = new dataType();
  finalData = {
    Statement: [],
    newBucketData: {},
    poolId: localStorage.getItem("poolId"),
    region: localStorage.getItem("region")
  };
  policyAction = { tempData: [] };
  Statement: any;
  Submitted: boolean = false;

  constructor(
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrManager
  ) {}

  ngOnInit(): void {
    this.gets3List();
  }
  gets3List() {
    return this.dataService.getBucketList().subscribe((Data: any) => {
      console.log(Data);
      this.data = Data.Data.Buckets;
    });
  }

  addPermission() {
    this.Statement = {
      Effect: "Deny",
      Action: [],
      Resource: "arn:aws:s3:::" + this.bucketData.bucket
    };

    this.bucketData.read == true
      ? this.Statement.Action.push("s3:GetObject", "s3:ListBucket")
      : false;
    this.bucketData.write == true
      ? this.Statement.Action.push("s3:PutObject", "s3:DeleteObject")
      : false;
    // this.bucketData.full == true ? this.Statement.Action.push("s3:*") : false;
    this.finalData.Statement.push(this.Statement);
    console.log(this.bucketData);
    // console.log(this.finalData.Statement.length)

    // let bucketStatement = {
    //   Effect: "Allow",
    //   Action: ["s3:ListAllMyBuckets"],
    //   Resource: "arn:aws:s3:::*"
    // };
    // if (this.finalData.Statement.length == 1) {
    //   this.finalData.Statement.push(bucketStatement);
    // }

    this.policyAction.tempData.push({
      bucket: this.bucketData.bucket,
      read: this.bucketData.read == true ? true : false,
      write: this.bucketData.write == true ? true : false,
      full: this.bucketData.full == true ? true : false
    });
    console.log(this.policyAction);
    this.Submitted = true;
  }

  addGroup() {
    this.Statement = {
      Effect: "Allow",
      Action: [],
      Resource: "*"
    };
    //Policies for Cognito
    this.bucketData.cread == true
      ? this.Statement.Action.push(
          "iam:ListUsers",
          "iam:GetRolePolicy",
          "iam:PassRole",
          "cognito-identity:Describe*",
          "cognito-identity:Get*",
          "cognito-identity:List*",
          "cognito-idp:Describe*",
          "cognito-idp:AdminGetUser",
          "cognito-idp:List*",
          "cognito-sync:Describe*",
          "cognito-sync:Get*",
          "cognito-sync:List*",
          "iam:ListOpenIdConnectProviders",
          "iam:ListRoles",
          "sns:ListPlatformApplications"
        )
      : false;
    this.bucketData.cwrite == true
      ? this.Statement.Action.push(
          "iam:CreateRole",
          "iam:PutRolePolicy",
          "cognito-idp:CreateGroup",
          "cognito-idp:AddCustomAttributes",
          "cognito-idp:AdminAddUserToGroup",
          "cognito-idp:AdminConfirmSignUp",
          "cognito-idp:AdminCreateUser",
          "cognito-idp:AdminDeleteUser",
          "cognito-idp:AdminDeleteUserAttributes",
          "cognito-idp:AdminDisableUser",
          "cognito-idp:AdminEnableUser",
          "cognito-idp:AdminResetUserPassword",
          "cognito-idp:AdminUpdateUserAttributes",
          "cognito-idp:ChangePassword",
          "cognito-idp:ConfirmForgotPassword",
          "cognito-idp:ConfirmSignUp",
          "cognito-idp:CreateGroup",
          "cognito-idp:DeleteGroup",
          "cognito-idp:DeleteUser",
          "cognito-idp:DeleteUserAttributes",
          "cognito-idp:ForgotPassword",
          "cognito-idp:SignUp",
          "cognito-idp:UpdateGroup",
          "cognito-idp:UpdateUserAttributes"

        )
      : false;
    this.bucketData.cfull == true
      ? this.Statement.Action.push(
          "cognito-identity:*",
          "cognito-idp:*",
          "cognito-sync:*",
          "iam:ListRoles",
          "iam:ListOpenIdConnectProviders",
          "sns:ListPlatformApplications"
        )
      : false;

    //Policies for s3

    this.bucketData.s3read == true
      ? this.Statement.Action.push("iam:PassRole", "s3:Get*", "s3:List*")
      : false;
    this.bucketData.s3write == true
      ? this.Statement.Action.push(
          "iam:UpdateRole",
          "iam:UpdateRolePolicy",
          "cognito-idp:UpdateGroup",
          "s3:CreateBucket",
          "s3:DeleteBucket",
          "s3:DeleteObject",
          "s3:PutObject"
          )
      : false;
    this.bucketData.s3full == true ? this.Statement.Action.push("s3:*") : false;

    //Policies for IAM

    this.bucketData.iamread == true
      ? this.Statement.Action.push(
          "iam:GenerateCredentialReport",
          "iam:GenerateServiceLastAccessedDetails",
          "iam:Get*",
          "iam:List*",
          "iam:SimulateCustomPolicy",
          "iam:SimulatePrincipalPolicy"
        )
      : false;
    this.bucketData.iamwrite == true
      ? this.Statement.Action.push(
          "iam:AddUserToGroup",
          "iam:CreateAccessKey",
          "iam:CreateGroup",
          "iam:CreateLoginProfile",
          "iam:CreateRole",
          "iam:CreateUser",
          "iam:DeleteAccessKey",
          "iam:DeleteAccountAlias",
          "iam:DeleteGroup",
          "iam:DeleteInstanceProfile",
          "iam:DeleteLoginProfile",
          "iam:DeleteRole",
          "iam:DeleteUser",
          "iam:RemoveUserFromGroup",
          "iam:UpdateAccessKey",
          "iam:UpdateGroup",
          "iam:UpdateLoginProfile",
          "iam:UpdateRole",
          "iam:UpdateUser"
        )
      : false;
    this.bucketData.iamfull == true
      ? this.Statement.Action.push("iam:*")
      : false;

    this.finalData.Statement.push(this.Statement);
    console.log(this.finalData.Statement);

    this.save();
  }

  private save(): void {
    console.log(this.finalData);
    this.finalData["newBucketData"] = {
      groupname: this.bucketData.groupname,
      desc: this.bucketData.desc
    };
    console.log(this.finalData);
    this.dataService.addGroup(this.finalData).subscribe((Data: any) => {
      if (typeof Data == "string") {
        var newData = JSON.parse(Data);
      } else {
        var newData = Data;
      }
      console.log(newData);
      if (newData.Status == "Error") {
        console.log(newData.Error.message);
        //alert(newData.Error.message);
        this.toastr.errorToastr(newData.Error.message, "oops!");
      } else if (newData.Status == "Success") {
        // alert("Group Created Successfully");
        this.toastr.successToastr("Group Created Successfully", "Success!");
        this.router.navigate(["/groups"]);
      }
    });
  }

  deletePolicy(bucketName) {
    // console.log(this.policyAction.tempData[0].bucket)
    for (var i = 0; i < this.policyAction.tempData.length; i++) {
      if (this.policyAction.tempData[i].bucket == bucketName) {
        this.policyAction.tempData.splice(i, 1);
      }
    }
    console.log(this.policyAction.tempData.length);
    if (this.policyAction.tempData.length < 1) {
      this.Submitted = false;
    }

    for (var i = 0; i < this.finalData.Statement.length; i++) {
      if (
        this.finalData.Statement[i].Resource.split(":")
          .pop()
          .split("/")[0] == bucketName
      ) {
        this.finalData.Statement.splice(i, 1);
        console.log(this.finalData.Statement);
        return null;
      }
    }
  }
}
